/* eslint-disable */
import { createContext, useContext, useEffect, useState } from "react";
import {
  onAuthStateChanged,
  isSignInWithEmailLink,
  signInWithEmailLink,
  signOut as firebaseSignOut,
} from "firebase/auth";
import { auth } from "../firebase";
import { COLOR, FONT } from "../utils/theme";
import SignIn from "./SignIn";
import Toast, { useToast } from "./Toast";

const AuthContext = createContext(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthGate");
  return ctx;
}

export default function AuthGate({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, showToast] = useToast();

  // Handle magic link completion
  useEffect(() => {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = localStorage.getItem("emailForSignIn");
      if (!email) {
        email = window.prompt("Please enter your email to confirm sign-in:");
      }
      if (email) {
        signInWithEmailLink(auth, email, window.location.href)
          .then(() => {
            localStorage.removeItem("emailForSignIn");
            window.history.replaceState(null, "", window.location.pathname);
          })
          .catch((e) => {
            console.error("[AuthGate] signInWithEmailLink failed:", e);
            showToast("Sign-in failed — try requesting a new link", "error");
          });
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Listen to auth state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const handleSignOut = () => firebaseSignOut(auth);

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: COLOR.cream,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <span style={{
          width: 32, height: 32,
          border: `3px solid ${COLOR.borderWarm}`,
          borderTopColor: COLOR.mauve,
          borderRadius: "50%",
          display: "inline-block",
          animation: "authSpin 0.8s linear infinite",
        }} />
        <style>{`
          @keyframes authSpin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, loading, signOut: handleSignOut }}>
      <Toast {...toast} />
      {user ? children : <SignIn />}
    </AuthContext.Provider>
  );
}
